import React from "react"
// Circular deps means we have to access helpers directly
import getMessage from "@irati/utils/lang/helpers/getMessage"
import {getErrorValues} from "@irati/utils/lang/formatError"
import {useSafeIntl} from "@irati/utils/lang/intlHook"
import ErrorText from "../ErrorText"
import {ErrorProps} from "."

type Props = ErrorProps

const LoadingError = (props: Props) => {
  const {error, errorMsg} = props
  const intl = useSafeIntl()
  return <ErrorText {...props}>{getMessage(intl?.formatMessage ?? null, errorMsg, getErrorValues(error))}</ErrorText>
}

export default LoadingError
